import { validServiceRate } from "./serviceCatalog";

const CURRENCY_PATTERN = /^[A-Z]{3}$/;
// Only the legacy local CODE amount format is migrated. Locale/symbol guesses
// would turn ambiguous display text into a financial amount.
const LEGACY_RATE_PATTERN = /^([A-Z]{3})[ \t]+((?:0|[1-9]\d{0,13}|[1-9]\d{0,2}(?:,\d{3}){1,4})(?:\.\d{1,4})?)$/;

export const normalizeLocalService = (service) => {
  if (!service || typeof service !== "object" || Array.isArray(service)) return service;
  let currency = typeof service.currency === "string" ? service.currency.trim().toUpperCase() : "";
  if (service.currency != null && service.currency !== "" && !CURRENCY_PATTERN.test(currency)) return service;

  const hasExactRate = service.exactRate != null;
  const source = hasExactRate ? service.exactRate : service.rate;
  if (typeof source !== "string" && typeof source !== "number") return service;
  let rate = String(source).trim();
  if (!hasExactRate) {
    const legacy = LEGACY_RATE_PATTERN.exec(rate);
    if (legacy) {
      if (currency && currency !== legacy[1]) return service;
      currency = legacy[1];
      rate = legacy[2].replace(/,/g, "");
    }
  }
  if (!CURRENCY_PATTERN.test(currency) || !validServiceRate(rate)) return service;
  return { ...service, rate, currency, ...(hasExactRate ? { exactRate: rate } : {}) };
};
